// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%236B7280%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 11L3 6h10l-5 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overscroll-behavior: none;  /* 바운스(당김/밀림) 방지 */
  overflow-x: hidden;         /* 필요 시 가로 스크롤도 차단 */
}

/* 페이지네이션 스타일 */
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
  gap: 1rem;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination-btn {
  padding: 0.5rem 0.75rem;
  border: 1px solid #e5e7eb;
  background-color: white;
  color: #374151;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  min-width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn:hover:not(.disabled) {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.pagination-btn.active {
  background-color: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f9fafb;
}

.pagination-dots {
  padding: 0.5rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.pagination-info {
  font-size: 0.875rem;
  color: #6b7280;
  text-align: center;
}

/* 기존 스타일 유지 */
.flex.gap-4.mb-6 {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-select {
  min-width: 160px;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f8fafc;
  color: #475569;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

.filter-select:hover {
  border-color: #cbd5e1;
  background-color: white;
}

.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.dashboard-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
  text-align: left;
}

.dashboard-loading {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
  color: #666;
}

.dashboard-error {
  text-align: center;
  padding: 2rem;
  color: #dc2626;
  font-weight: 500;
}

/* 기존 스타일은 유지, 그리드 부분만 수정 */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 5px;
  margin-top: 5px;
}

/* 작은 화면에서는 2열 */
@media (min-width: 640px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 중간 화면에서는 3열 */
@media (min-width: 1024px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 넓은 화면: 1440px 이상일 때 4열 */
@media (min-width: 1440px) {
  .cards-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}



/* 모바일 대응 */
@media (max-width: 768px) {
  .flex.gap-4.mb-6 {
    flex-direction: column;
    padding: 1rem;
  }

  .filter-select {
    width: 100%;
  }
}

/* 카드 스타일 */
.card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* 나머지 기존 스타일 유지 */
.card-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #1a1a1a;
}

.card-actions {
  display: flex;
  gap: 0.5rem;
}

.action-button {
  background: #9abce0;
  border: none;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.action-button:hover {
  background-color: #f3f4f6;
}

.action-button.save {
  color: #059669;
}

.action-button.cancel {
  color: #dc2626;
}

.action-button.edit {
  color: #4b5563;
}

.card-image-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card-image:hover {
  transform: scale(1.05);
}

.card-content {
  padding: 1rem;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
}

.edit-input {
  width: 90%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease;
}

.edit-input:focus {
  outline: none;
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
}

.description-input {
  width: 90%;
  min-height: 60px;
  resize: vertical;
  overflow: auto;
  line-height: 1.5;
  padding: 8px 12px;
}

.content-display {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.description {
  font-size: 0.875rem;
  color: #6b7280;
}

.status {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  /* margin-top: 1rem; */
  float: inline-end;
}

.status-badge.생성 {
  background-color: #fef3c7;
  color: #92400e;
}

.status-badge.검토완료 {
  background-color: #e0e7ff;
  color: #4338ca;
}

.status-badge.심의완료 {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.사용불가 {
  background-color: #dc2626;
  color: #d1fae5;
}

.status-toggle-group {
  margin: 1rem 0;
}

.status-buttons {
  display: flex;
  gap: 0.5rem;
}

.status-button {
  padding: 10px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: grey;
  cursor: pointer;
  color: black;
}

.status-button.active {
  background-color: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

/* .approval-number {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  font-size: 0.875rem;
  color: #666;
} */

/* .card-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem;
  background: white;
} */


.image-variations-container {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.current-image {
  margin-bottom: 1rem;
}

.variations-grid {
  margin-bottom: 1rem;
}

.variations-options {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 0.5rem;
}

.variation-option {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
}

.variation-option.selected {
  border-color: #0066cc;
}

.variation-thumbnail {
  width: 100%;
  height: auto;
  display: block;
}

.variation-controls {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.regenerate-button {
  background-color: #4CAF50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.regenerate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.apply-button {
  background-color: #0066cc;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.apply-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.card-id-badge{
  color: #212121;
  font-weight: bold;
  float: left;
}

.badge-container{
  display: flow-root;
  margin-bottom: 10px;
  padding: 10px;
  width: 80%;
  margin: 0 auto;
}

.card-controls{
  margin-top: 12px;
  margin-bottom: 12px;
  margin-right: auto;
  margin-left: auto;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
}

/* 전체 대시보드 레이아웃 */
.dashboard-container {
  display: grid;
  grid-template-columns: 250px 1fr; 
  gap: 24px;
  padding: 20px;
  min-height: 100vh;
}

/* .dashboard-container::after {
  content: "";
  display: block;
  clear: both;
} */

/* 좌측 필터 사이드바 */
.filter-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 검색창 스타일 */
.search-section {
  margin-bottom: 8px;
  display: flex;
  gap: 4px;
}

.search-input {
  flex: 1 1;
  padding: 10px 12px;
  border: 2px solid #e1e1e1;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-input::placeholder {
  color: #999;
}

.search-button {
  padding: 10px 14px;
  background-color: #3b82f6;
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-button:hover {
  background-color: #2563eb;
}

.search-button:active {
  background-color: #1d4ed8;
}

.search-clear-button {
  padding: 10px 12px;
  background: #f3f4f6;
  border: none;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-clear-button:hover {
  background: #e5e7eb;
  color: #333;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-category {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.filter-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #333;
}

/* 메인 컨텐츠 영역 */
.main-content {
  /* padding: 20px; */
  font-size: 1rem;
  color: #1f2937;
  line-height: 1.5;
  /* margin-left: 230px;  */
  display: grid;
}

/* 반응형 처리 */
@media (max-width: 1024px) {
  .dashboard-container {
    grid-template-columns: 1fr;
  }
  
  .filter-sidebar {
    position: static;
    margin-bottom: 24px;
  }
}



/* .filter-sidebar {
  background: white;
  display: block;
  float: left;
  width: 250px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  border-right: 1px solid #e1e1e1;
  margin: 10px;
  border-radius: 25px;
  border: 1px solid #000;
} */

.filter-sidebar {
  background: white;
  position: fixed;
  top: calc(10vh + 40px);
  left: 0;
  width: 250px;
  padding: 20px;
  border-right: 1px solid #e1e1e1;
  margin: 0;
  border: none;
  border-radius: 0;
  height: 80vh;
  overflow-y: auto;
  z-index: 9999;
}

.filter-section {
  padding: 20px 0;
}

.filter-group {
  border-bottom: 1px solid #f0f0f0;
}

.filter-toggle-button {
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  background-color: #DCDCDC;
}

.filter-toggle-button:hover {
  background-color: #545454;
  color: #FFF;
}

.toggle-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.toggle-icon.open {
  transform: rotate(180deg);
}

.filter-options {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.filter-option {
  width: 100%;
  padding: 8px 16px;
  text-align: left;
  background: none;
  border: none;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.filter-option:hover {
  background-color: #f8f9fa;
  color: #333;
}

.filter-option.selected {
  background-color: #0ea5e975;
  color: #333;
  font-weight: 500;
}

/* 헤더 스타일링 */
.dashboard-container header {
  position: fixed;
  z-index: 9999;
  width: 250px;
  padding: 20px;
  height: 10vh;
  background: white;
  left: 0;
  top: 0;
}

.dashboard-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.download-controls {
  margin-bottom: 24px;
}

.download-all-button {
  padding: 10px 20px;
  background-color: #0ca678;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.download-all-button:hover {
  background-color: #099268;
}

.wrap-side{
  background-color: #f0f2f5;
}
.text-with-truncation {
  display: inline-block;
  max-width: 100%; /* 텍스트가 일정 너비를 넘어가지 않도록 설정 */
  white-space: nowrap; /* 텍스트 줄 바꿈을 방지 */
  overflow: hidden;
  text-overflow: clip; /* '...' 대신 실제 텍스트 자름 */
}

.truncation-indicator {
  display: inline-block;
  width: 16px;  /* 원하는 크기 조정 */
  height: 16px;
  margin-left: 4px;  /* 텍스트와 이미지 간 간격 조정 */
  cursor: pointer;  /* 마우스 커서를 손 모양으로 변경 */
}

.truncation-indicator img {
  width: 100%;
  height: 100%;
  border-radius: 50%;  /* 원형 이미지로 만들기 */
}

.truncation-indicator[title] {
  position: relative;
}

.truncation-indicator[title]:hover::after {
  content: attr(title);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  font-weight: bold;
}

.image-shape-selector {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.shape-label {
  font-weight: 600;
  color: #333;
}

.shape-buttons {
  display: flex;
  gap: 1rem;
}

.shape-button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}

.shape-button.active {
  background: #007bff;
  color: white;
  border-color: #0056b3;
}

.shape-button:hover {
  background: #f0f0f0;
}

.shape-button.active:hover {
  background: #0056b3;
}

/* 폰트 선택 스타일 */
.font-selector {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.font-label {
  font-weight: 600;
  color: #333;
}

.font-select {
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f8fafc;
  color: #475569;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

.font-select:hover {
  border-color: #cbd5e1;
  background-color: white;
}

.font-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 배경 선택 스타일 */
.background-selector {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.background-label {
  font-weight: 600;
  color: #333;
}

.background-select {
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f8fafc;
  color: #475569;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

.background-select:hover {
  border-color: #cbd5e1;
  background-color: white;
}

.background-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* GIF 생성 버튼 스타일 */
.gif-button {
  background-color: #ff6b6b;
  color: white;
  padding: 10px 22px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  line-height: 1;
  max-height: 32px;
  width: 75px;
}

.gif-button:hover:not(:disabled) {
  background-color: #ff5252;
}

.gif-button:disabled {
  background-color: #ffa5a5;
  cursor: not-allowed;
  opacity: 0.7;
}

.gif-button.success {
  background-color: #4CAF50;
  animation: buttonSuccess 0.5s ease;
}

@keyframes buttonSuccess {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* 버튼 내부 체크마크 SVG */
.button-checkmark-svg {
  width: 20px;
  height: 20px;
}

.button-checkmark-circle {
  stroke: #fff;
  stroke-width: 2;
  stroke-miterlimit: 10;
  animation: buttonStrokeCircle 0.4s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.button-checkmark-check {
  stroke: #fff;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: buttonStrokeCheck 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.2s forwards;
}

@keyframes buttonStrokeCircle {
  0% {
    stroke-dasharray: 0 157;
  }
  100% {
    stroke-dasharray: 157 157;
  }
}

@keyframes buttonStrokeCheck {
  100% {
    stroke-dashoffset: 0;
  }
}

/* 스피너 애니메이션 */
.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 토글 스위치 컨테이너 */
.toggle-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
}

.toggle-label {
  font-size: 14px;
  color: #333;
  font-weight: 700;
}

/* 토글 스위치 */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #007bff;
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #007bff;
}

/* 성공 애니메이션 (애플 스타일) */
.success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  animation: fadeIn 0.3s ease-in;
}

.success-checkmark {
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  animation: scaleIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.checkmark-svg {
  width: 56px;
  height: 56px;
}

.checkmark-circle {
  stroke: #4CAF50;
  stroke-width: 2;
  stroke-miterlimit: 10;
  animation: strokeCircle 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
  stroke: #4CAF50;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: strokeCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;
}

/* 애니메이션 정의 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes strokeCircle {
  0% {
    stroke-dasharray: 0 157;
  }
  100% {
    stroke-dasharray: 157 157;
  }
}

@keyframes strokeCheck {
  100% {
    stroke-dashoffset: 0;
  }
}

/* 이미지 재생성 섹션 스타일 */
.image-regenerate-section {
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 이미지 재생성 버튼 스타일 */
.regenerate-single-button {
  width: 100%;
  height: 48px;
  padding: 12px 24px;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.regenerate-single-button:hover:not(:disabled) {
  background-color: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

.regenerate-single-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.regenerate-single-button.loading {
  background-color: #6b7280;
  cursor: wait;
  width: 100%;
  height: 48px;
}

.regenerate-single-button .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/css/card_dashboard.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB,GAAG,kBAAkB;EAC9C,kBAAkB,UAAU,oBAAoB;AAClD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAAgM;EAChM,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;;;AAIA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;;;;GAMG;;AAEH;;;;;;;GAOG;;;AAGH;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;GAIG;;AAEH,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;;;AAIA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,eAAe,EAAE,4BAA4B;EAC7C,mBAAmB,EAAE,iBAAiB;EACtC,gBAAgB;EAChB,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;EACE,qBAAqB;EACrB,WAAW,GAAG,cAAc;EAC5B,YAAY;EACZ,gBAAgB,GAAG,qBAAqB;EACxC,eAAe,GAAG,sBAAsB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,GAAG,gBAAgB;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAAgM;EAChM,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAAgM;EAChM,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,8EAA8E;AAChF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;AACtC","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overscroll-behavior: none;  /* 바운스(당김/밀림) 방지 */\n  overflow-x: hidden;         /* 필요 시 가로 스크롤도 차단 */\n}\n\n/* 페이지네이션 스타일 */\n.pagination-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 2rem 0;\n  gap: 1rem;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pagination-btn {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  color: #374151;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  min-width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-btn:hover:not(.disabled) {\n  background-color: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.pagination-btn.active {\n  background-color: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.pagination-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f9fafb;\n}\n\n.pagination-dots {\n  padding: 0.5rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: #6b7280;\n  text-align: center;\n}\n\n/* 기존 스타일 유지 */\n.flex.gap-4.mb-6 {\n  display: flex;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.filter-select {\n  min-width: 160px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #f8fafc;\n  color: #475569;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236B7280' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  padding-right: 2.5rem;\n}\n\n.filter-select:hover {\n  border-color: #cbd5e1;\n  background-color: white;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.dashboard-title {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 2rem;\n  text-align: left;\n}\n\n.dashboard-loading {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.dashboard-error {\n  text-align: center;\n  padding: 2rem;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n/* 기존 스타일은 유지, 그리드 부분만 수정 */\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 5px;\n  margin-top: 5px;\n}\n\n/* 작은 화면에서는 2열 */\n@media (min-width: 640px) {\n  .cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* 중간 화면에서는 3열 */\n@media (min-width: 1024px) {\n  .cards-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* 넓은 화면: 1440px 이상일 때 4열 */\n@media (min-width: 1440px) {\n  .cards-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n\n\n/* 모바일 대응 */\n@media (max-width: 768px) {\n  .flex.gap-4.mb-6 {\n    flex-direction: column;\n    padding: 1rem;\n  }\n\n  .filter-select {\n    width: 100%;\n  }\n}\n\n/* 카드 스타일 */\n.card {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease;\n  overflow: hidden;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* 나머지 기존 스타일 유지 */\n.card-header {\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n}\n\n.card-title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #1a1a1a;\n}\n\n.card-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.action-button {\n  background: #9abce0;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.action-button:hover {\n  background-color: #f3f4f6;\n}\n\n.action-button.save {\n  color: #059669;\n}\n\n.action-button.cancel {\n  color: #dc2626;\n}\n\n.action-button.edit {\n  color: #4b5563;\n}\n\n.card-image-container {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  position: relative;\n}\n\n.card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.card-image:hover {\n  transform: scale(1.05);\n}\n\n.card-content {\n  padding: 1rem;\n}\n\n.edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n}\n\n.edit-input {\n  width: 90%;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease;\n}\n\n.edit-input:focus {\n  outline: none;\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);\n}\n\n.description-input {\n  width: 90%;\n  min-height: 60px;\n  resize: vertical;\n  overflow: auto;\n  line-height: 1.5;\n  padding: 8px 12px;\n}\n\n.content-display {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.description {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.status {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n  padding-top: 0.5rem;\n  border-top: 1px solid #eee;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  /* margin-top: 1rem; */\n  float: inline-end;\n}\n\n.status-badge.생성 {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.검토완료 {\n  background-color: #e0e7ff;\n  color: #4338ca;\n}\n\n.status-badge.심의완료 {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.사용불가 {\n  background-color: #dc2626;\n  color: #d1fae5;\n}\n\n.status-toggle-group {\n  margin: 1rem 0;\n}\n\n.status-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.status-button {\n  padding: 10px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background: grey;\n  cursor: pointer;\n  color: black;\n}\n\n.status-button.active {\n  background-color: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n/* .approval-number {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  font-size: 0.875rem;\n  color: #666;\n} */\n\n/* .card-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 1rem;\n  background: white;\n} */\n\n\n.image-variations-container {\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.current-image {\n  margin-bottom: 1rem;\n}\n\n.variations-grid {\n  margin-bottom: 1rem;\n}\n\n.variations-options {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.variation-option {\n  cursor: pointer;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.variation-option.selected {\n  border-color: #0066cc;\n}\n\n.variation-thumbnail {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.variation-controls {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.regenerate-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.regenerate-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.apply-button {\n  background-color: #0066cc;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.apply-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.card-id-badge{\n  color: #212121;\n  font-weight: bold;\n  float: left;\n}\n\n.badge-container{\n  display: flow-root;\n  margin-bottom: 10px;\n  padding: 10px;\n  width: 80%;\n  margin: 0 auto;\n}\n\n.card-controls{\n  margin-top: 12px;\n  margin-bottom: 12px;\n  margin-right: auto;\n  margin-left: auto;\n  width: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n}\n\n/* 전체 대시보드 레이아웃 */\n.dashboard-container {\n  display: grid;\n  grid-template-columns: 250px 1fr; \n  gap: 24px;\n  padding: 20px;\n  min-height: 100vh;\n}\n\n/* .dashboard-container::after {\n  content: \"\";\n  display: block;\n  clear: both;\n} */\n\n/* 좌측 필터 사이드바 */\n.filter-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* 검색창 스타일 */\n.search-section {\n  margin-bottom: 8px;\n  display: flex;\n  gap: 4px;\n}\n\n.search-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 2px solid #e1e1e1;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #333;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-input::placeholder {\n  color: #999;\n}\n\n.search-button {\n  padding: 10px 14px;\n  background-color: #3b82f6;\n  border: none;\n  border-radius: 6px;\n  color: white;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.search-button:hover {\n  background-color: #2563eb;\n}\n\n.search-button:active {\n  background-color: #1d4ed8;\n}\n\n.search-clear-button {\n  padding: 10px 12px;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 6px;\n  color: #666;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.search-clear-button:hover {\n  background: #e5e7eb;\n  color: #333;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-category {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.filter-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n  color: #333;\n}\n\n/* 메인 컨텐츠 영역 */\n.main-content {\n  /* padding: 20px; */\n  font-size: 1rem;\n  color: #1f2937;\n  line-height: 1.5;\n  /* margin-left: 230px;  */\n  display: grid;\n}\n\n/* 반응형 처리 */\n@media (max-width: 1024px) {\n  .dashboard-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .filter-sidebar {\n    position: static;\n    margin-bottom: 24px;\n  }\n}\n\n\n\n/* .filter-sidebar {\n  background: white;\n  display: block;\n  float: left;\n  width: 250px;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  overflow-y: auto;\n  border-right: 1px solid #e1e1e1;\n  margin: 10px;\n  border-radius: 25px;\n  border: 1px solid #000;\n} */\n\n.filter-sidebar {\n  background: white;\n  position: fixed;\n  top: calc(10vh + 40px);\n  left: 0;\n  width: 250px;\n  padding: 20px;\n  border-right: 1px solid #e1e1e1;\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  height: 80vh;\n  overflow-y: auto;\n  z-index: 9999;\n}\n\n.filter-section {\n  padding: 20px 0;\n}\n\n.filter-group {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.filter-toggle-button {\n  width: 100%;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  background-color: #DCDCDC;\n}\n\n.filter-toggle-button:hover {\n  background-color: #545454;\n  color: #FFF;\n}\n\n.toggle-icon {\n  font-size: 12px;\n  transition: transform 0.3s ease;\n}\n\n.toggle-icon.open {\n  transform: rotate(180deg);\n}\n\n.filter-options {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n}\n\n.filter-option {\n  width: 100%;\n  padding: 8px 16px;\n  text-align: left;\n  background: none;\n  border: none;\n  font-size: 14px;\n  color: #666;\n  cursor: pointer;\n}\n\n.filter-option:hover {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.filter-option.selected {\n  background-color: #0ea5e975;\n  color: #333;\n  font-weight: 500;\n}\n\n/* 헤더 스타일링 */\n.dashboard-container header {\n  position: fixed;\n  z-index: 9999;\n  width: 250px;\n  padding: 20px;\n  height: 10vh;\n  background: white;\n  left: 0;\n  top: 0;\n}\n\n.dashboard-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.download-controls {\n  margin-bottom: 24px;\n}\n\n.download-all-button {\n  padding: 10px 20px;\n  background-color: #0ca678;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.download-all-button:hover {\n  background-color: #099268;\n}\n\n.wrap-side{\n  background-color: #f0f2f5;\n}\n.text-with-truncation {\n  display: inline-block;\n  max-width: 100%; /* 텍스트가 일정 너비를 넘어가지 않도록 설정 */\n  white-space: nowrap; /* 텍스트 줄 바꿈을 방지 */\n  overflow: hidden;\n  text-overflow: clip; /* '...' 대신 실제 텍스트 자름 */\n}\n\n.truncation-indicator {\n  display: inline-block;\n  width: 16px;  /* 원하는 크기 조정 */\n  height: 16px;\n  margin-left: 4px;  /* 텍스트와 이미지 간 간격 조정 */\n  cursor: pointer;  /* 마우스 커서를 손 모양으로 변경 */\n}\n\n.truncation-indicator img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;  /* 원형 이미지로 만들기 */\n}\n\n.truncation-indicator[title] {\n  position: relative;\n}\n\n.truncation-indicator[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 5px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 10;\n  font-weight: bold;\n}\n\n.image-shape-selector {\n  margin: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.shape-label {\n  font-weight: 600;\n  color: #333;\n}\n\n.shape-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.shape-button {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.shape-button.active {\n  background: #007bff;\n  color: white;\n  border-color: #0056b3;\n}\n\n.shape-button:hover {\n  background: #f0f0f0;\n}\n\n.shape-button.active:hover {\n  background: #0056b3;\n}\n\n/* 폰트 선택 스타일 */\n.font-selector {\n  margin: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.font-label {\n  font-weight: 600;\n  color: #333;\n}\n\n.font-select {\n  padding: 0.75rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #f8fafc;\n  color: #475569;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236B7280' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  padding-right: 2.5rem;\n}\n\n.font-select:hover {\n  border-color: #cbd5e1;\n  background-color: white;\n}\n\n.font-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* 배경 선택 스타일 */\n.background-selector {\n  margin: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.background-label {\n  font-weight: 600;\n  color: #333;\n}\n\n.background-select {\n  padding: 0.75rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #f8fafc;\n  color: #475569;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236B7280' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  padding-right: 2.5rem;\n}\n\n.background-select:hover {\n  border-color: #cbd5e1;\n  background-color: white;\n}\n\n.background-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* GIF 생성 버튼 스타일 */\n.gif-button {\n  background-color: #ff6b6b;\n  color: white;\n  padding: 10px 22px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n  line-height: 1;\n  max-height: 32px;\n  width: 75px;\n}\n\n.gif-button:hover:not(:disabled) {\n  background-color: #ff5252;\n}\n\n.gif-button:disabled {\n  background-color: #ffa5a5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.gif-button.success {\n  background-color: #4CAF50;\n  animation: buttonSuccess 0.5s ease;\n}\n\n@keyframes buttonSuccess {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* 버튼 내부 체크마크 SVG */\n.button-checkmark-svg {\n  width: 20px;\n  height: 20px;\n}\n\n.button-checkmark-circle {\n  stroke: #fff;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n  animation: buttonStrokeCircle 0.4s cubic-bezier(0.65, 0, 0.45, 1) forwards;\n}\n\n.button-checkmark-check {\n  stroke: #fff;\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  animation: buttonStrokeCheck 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.2s forwards;\n}\n\n@keyframes buttonStrokeCircle {\n  0% {\n    stroke-dasharray: 0 157;\n  }\n  100% {\n    stroke-dasharray: 157 157;\n  }\n}\n\n@keyframes buttonStrokeCheck {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* 스피너 애니메이션 */\n.spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #ffffff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* 토글 스위치 컨테이너 */\n.toggle-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-left: auto;\n}\n\n.toggle-label {\n  font-size: 14px;\n  color: #333;\n  font-weight: 700;\n}\n\n/* 토글 스위치 */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background-color: #007bff;\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(20px);\n}\n\n.toggle-switch input:focus + .toggle-slider {\n  box-shadow: 0 0 1px #007bff;\n}\n\n/* 성공 애니메이션 (애플 스타일) */\n.success-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 10000;\n  animation: fadeIn 0.3s ease-in;\n}\n\n.success-checkmark {\n  width: 80px;\n  height: 80px;\n  background-color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  animation: scaleIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.checkmark-svg {\n  width: 56px;\n  height: 56px;\n}\n\n.checkmark-circle {\n  stroke: #4CAF50;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n  animation: strokeCircle 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;\n}\n\n.checkmark-check {\n  stroke: #4CAF50;\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  animation: strokeCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;\n}\n\n/* 애니메이션 정의 */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes strokeCircle {\n  0% {\n    stroke-dasharray: 0 157;\n  }\n  100% {\n    stroke-dasharray: 157 157;\n  }\n}\n\n@keyframes strokeCheck {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* 이미지 재생성 섹션 스타일 */\n.image-regenerate-section {\n  margin: 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* 이미지 재생성 버튼 스타일 */\n.regenerate-single-button {\n  width: 100%;\n  height: 48px;\n  padding: 12px 24px;\n  background-color: #10b981;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.regenerate-single-button:hover:not(:disabled) {\n  background-color: #059669;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);\n}\n\n.regenerate-single-button:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.regenerate-single-button.loading {\n  background-color: #6b7280;\n  cursor: wait;\n  width: 100%;\n  height: 48px;\n}\n\n.regenerate-single-button .spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ffffff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
